import {useEffect, useState} from "react";
import "./CardPanier.scss";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCircleInfo, faXmark} from "@fortawesome/free-solid-svg-icons";
import RedirectToProductDetails from "../RedirectToProductsDetails/RedirectToProductDetails";
import Cookies from "js-cookie";

function CardPanier({
                        name,
                        price,
                        amount,
                        index,
                        cover,
                        setTotalPanier,
                        idProduct,
                        cart, updateCart, informationsComplementaires
                    }) {
    const [selectedValue, setSelectedValue] = useState("");
    const [imageClique, setImageClique] = useState(false);
    localStorage.setItem("cart", JSON.stringify(cart));
    const jwtToken = Cookies.get("auth_token");
    const nbArticles = JSON.parse(localStorage.getItem("nbArticles"));

    const removeFromCart = (index) => {
        if (jwtToken) {
            const getBasketClientFromDatabase = async () => {
                try {
                    const response = await fetch(`${process.env.REACT_APP_API_URL}panier/delete`, {
                        method: "DELETE",
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${jwtToken}`
                        },
                        body: JSON.stringify({index: index}),
                    });
                    if (response.ok) {
                        const data = await response.json();
                        console.log(data);
                        updateCart(data.contenuPanier);
                        localStorage.setItem("nbArticles", JSON.stringify(nbArticles - 1));
                        window.location.reload();
                    } else {
                        console.error("Panier non trouvé");
                    }
                } catch (error) {
                    console.error("Erreur de connexion au serveur:", error);
                }
            }
            getBasketClientFromDatabase().then(r => console.log(r));
        } else {
            console.log(index);
            const updatedCart = [...cart];
            updatedCart.splice(index, 1);
            updateCart(updatedCart);
            localStorage.setItem("cart", JSON.stringify(updatedCart));
            if (nbArticles > 0) {
                localStorage.setItem("nbArticles", JSON.stringify(nbArticles - 1));
                window.location.reload();
            }
        }
    };

    const total = cart.reduce(
        (acc, plantType) => acc + plantType.amount * plantType.price,
        0
    );
    useEffect(() => {
        localStorage.setItem("cart", JSON.stringify(cart));
        localStorage.setItem("total", JSON.stringify(total));
        setTotalPanier(total);
    }, [total]);

    useEffect(() => {
        if (jwtToken && selectedValue !== "") {
            const panierInfos = {
                idProduct: idProduct,
                amount: selectedValue,
            }
            localStorage.setItem("nbElement", JSON.stringify(selectedValue));
            const patchAmountOfThisProductInDatabase = async () => {
                //setDataLoading(true);
                try {
                    const response = await fetch(
                        `${process.env.REACT_APP_API_URL}panier/update`, {
                            method: "PATCH",
                            headers: {
                                "Content-Type": "application/json",
                                Authorization: `Bearer ${jwtToken}`
                            },
                            body: JSON.stringify({panierInfos}),
                        },
                    );
                    if (response.ok) {
                        const panier = await response.json();
                        console.log(panier);
                        updateCart(panier.contenuPanier);
                    }
                } catch (error) {
                    console.error(error);
                } finally {
                    //setProductAdd(true);
                    //setDataLoading(false);
                }
            };
            patchAmountOfThisProductInDatabase().then(r => console.log(r));
        } else {
            if (selectedValue !== "") {
                const updatedCart = [...cart];
                const productIndex = updatedCart.findIndex((product) => product.name === name);
                if (productIndex !== -1) {
                    updatedCart[productIndex] = {
                        ...updatedCart[productIndex],
                        amount: selectedValue,
                    };
                    updateCart(updatedCart);
                    setTotalPanier(total);
                }
            }
            setTotalPanier(total);
        }
    }, [selectedValue]);

    return (
        <div className="card-panier-premium">
            <div className="card-panier-left">
                <div className="card-panier-img-container" onClick={() => setImageClique(true)}>
                    <img src={cover} alt={name} />
                    {imageClique && (
                        <RedirectToProductDetails
                            idProduct={idProduct}
                            imageClique={imageClique}
                        />
                    )}
                </div>
                
                <div className="card-panier-infos">
                    <h4 className="card-panier-title">{name}</h4>
                    <p className="card-panier-price">{price.toFixed(2)} €</p>
                    
                    {informationsComplementaires && (
                        <div className="card-panier-details">
                            <FontAwesomeIcon icon={faCircleInfo} />
                            <p>{informationsComplementaires}</p>
                        </div>
                    )}
                </div>
            </div>

            <div className="card-panier-right">
                <div className="card-panier-qty">
                    <label>Qté :</label>
                    <select
                        value={selectedValue}
                        onChange={(e) => setSelectedValue(parseInt(e.target.value))}
                    >
                        <option value={amount} style={{display: 'none'}}>{amount}</option>
                        <option value="1">1</option>
                        <option value="2">2</option>
                        <option value="3">3</option>
                        <option value="4">4</option>
                        <option value="5">5</option>
                        <option value="6">6</option>
                        <option value="7">7</option>
                        <option value="8">8</option>
                        <option value="9">9</option>
                    </select>
                </div>

                <button className="btn-remove-item" onClick={() => removeFromCart(index)} title="Supprimer l'article">
                    <FontAwesomeIcon icon={faXmark} />
                </button>
            </div>
        </div>
    );
}

export default CardPanier;
